import type { RequestParams } from '@/shared/api';
import type { RoleItemListParams } from '../model/types';

export const ROLE_KEYS = {
  all: ['role'] as const,
  list: (params?: RequestParams) => [...ROLE_KEYS.all, 'list', params] as const,
  detail: (id: number | string) => [...ROLE_KEYS.all, 'detail', id] as const,
  permissions: () => [...ROLE_KEYS.all, 'permissions'] as const,
  itemList: (params?: RoleItemListParams) => [...ROLE_KEYS.all, 'item-list', params] as const,
};
